/// <amd-module name="VSS/Features/Frame/FPSLink/FPSLink" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { FPSLinkComponentProps } from "./FPSLink.Props";
import { Link } from "VSSUI/Link";

export class FPSLink extends VssComponent<FPSLinkComponentProps, {}> {
    public render(): JSX.Element {
        const linkProps = {
            ...this.props,
            onClick: this.onClick
        };

        return <Link {...linkProps} />;
    }

    private onClick = (event: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => {
        this.props.onClick && this.props.onClick(event);

        if (!event.isDefaultPrevented()) {
            if (this.props.href && this.props.supportsFPS !== false) {
                onClickFPS(this.context.pageContext, this.props.href, true, event, {
                    telemetrySource: this.props.telemetrySource,
                    telemetryProperties: this.props.telemetryProperties,
                    navigationId: this.props.navigationId
                });
            } else if (this.props.telemetrySource) {
                const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
                telemetryService.publishEvent("WebPlatform", "Link", {
                    ...(this.props.telemetryProperties || {}),
                    source: this.props.telemetrySource
                });
            }
        }
    };
}
